import React from "react";
import {
  FaWhatsapp,
  FaTelegramPlane,
  FaLinkedin,
  FaInstagram,
  FaPhone,
} from "react-icons/fa";
import { FaEnvelope, FaXTwitter } from "react-icons/fa6";
import conf from "../../conf/conf";

function Contact({ isOpen, onClose }) {
  if (!isOpen) return null;

  const {
    whatsapp_url,
    telegram_url,
    instagram_url,
    twitter_url,
    linkedin_url,
    phone_number,
    email_id,
  } = conf;

  const iconClasses =
    "text-white p-5 rounded-full hover:scale-110 transition-transform flex items-center justify-center";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose} // Close when clicking outside
    >
      <div
        className="bg-white dark:bg-gray-700 p-8 rounded-xl relative max-w-3xl w-full"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
            Contact
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-900 dark:hover:text-white text-3xl"
          >
            ✕
          </button>
        </div>

        {/* Divider */}
        <hr className="border-gray-300 dark:border-gray-600 mb-6" />

        <div className="flex flex-wrap md:flex-nowrap justify-center gap-6 md:gap-10 overflow-x-auto md:overflow-visible">
          <a
            href={whatsapp_url}
            target="_blank"
            rel="noopener noreferrer"
            className={`${iconClasses} bg-green-500`}
          >
            <FaWhatsapp size={25} className="md:size-35" />
          </a>
          <a
            href={telegram_url}
            target="_blank"
            rel="noopener noreferrer"
            className={`${iconClasses} bg-sky-500`}
          >
            <FaTelegramPlane size={25} className="md:size-35" />
          </a>
          <a
            href={twitter_url}
            target="_blank"
            rel="noopener noreferrer"
            className={`${iconClasses} bg-blue-400`}
          >
            <FaXTwitter size={25} className="md:size-35" />
          </a>
          <a
            href={linkedin_url}
            target="_blank"
            rel="noopener noreferrer"
            className={`${iconClasses} bg-blue-600`}
          >
            <FaLinkedin size={25} className="md:size-35" />
          </a>
          <a
            href={instagram_url}
            target="_blank"
            rel="noopener noreferrer"
            className={`${iconClasses} bg-pink-500`}
          >
            <FaInstagram size={25} className="md:size-35" />
          </a>
          <a
            href={`mailto:${email_id}`}
            className={`${iconClasses} bg-red-500`}
          >
            <FaEnvelope size={25} className="md:size-35" />
          </a>
          <a
            href={`tel:${phone_number}`}
            className={`${iconClasses} bg-gray-600`}
          >
            <FaPhone size={25} className="md:size-35" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
